export default {
  home_about: {
    badge: 'À propos de AllChinaBuy Sheet',
    title: 'Votre compagnon d\'achat\nultime',
    p1: 'Le spreadsheet AllChinaBuy est devenu un outil essentiel pour des milliers d\'acheteurs avertis dans le monde entier. Que vous cherchiez les dernières sorties de sneakers, des pièces streetwear premium ou des bijoux de luxe cachés, un spreadsheet bien organisé vous fait gagner des heures de navigation.',
    p2: 'Notre répertoire AllChinaBuy spreadsheet 2026 rassemble la collection la plus complète de trouvailles vérifiées — des chaussures et sweats à capuche aux sacs, accessoires et bien plus encore. Chaque entrée est régulièrement mise à jour.',
    p3: 'Ce qui distingue notre répertoire, c\'est le niveau de curation. Chaque entrée est examinée manuellement pour sa précision et sa pertinence.',
    cta1: 'Visiter la boutique principale',
    cta2: 'Lire le guide complet',
  },
  home_trust: {
    badge: 'Pourquoi nous choisir',
    title: 'Approuvé par des milliers d\'acheteurs',
    subtitle: 'Notre répertoire AllChinaBuy spreadsheet est fondé sur la fiabilité, la fraîcheur et les retours réels des utilisateurs.',
    t1: 'Mis à jour hebdomadairement',
    t1d: 'Notre répertoire est actualisé chaque semaine avec les dernières trouvailles pour que vous ne manquiez jamais un nouveau drop.',
    t2: 'Qualité vérifiée',
    t2d: 'Chaque spreadsheet est examiné manuellement avant d\'être répertorié. Nous vérifions les liens morts, les prix obsolètes et les descriptions incorrectes.',
    t3: 'Catégories organisées',
    t3d: 'Naviguez parmi 14 catégories soigneusement organisées pour trouver exactement ce dont vous avez besoin en quelques secondes.',
    t4: 'Navigation rapide',
    t4d: 'Les liens directs vers des annonces de produits vérifiés éliminent les suppositions et vous permettent de passer de la navigation à l\'achat plus vite.',
    t5: 'Guides comparatifs',
    t5d: 'Les comparaisons côte à côte vous aident à évaluer différentes options de spreadsheet AllChinaBuy avant de vous engager.',
    t6: 'Dernières trouvailles',
    t6d: 'Gardez une longueur d\'avance sur les tendances avec un accès précoce aux nouvelles découvertes et aux bonnes affaires discrètes.',
  },
  home_articles: {
    badge: 'Derniers guides',
    title: 'Articles d\'experts & Ressources',
    subtitle: 'Plongez plus profondément dans le monde des spreadsheets AllChinaBuy avec des guides approfondis et des conseils d\'experts.',
    more: 'D\'autres guides arrivent bientôt — ajoutez cette page à vos favoris et revenez chaque semaine.',
  },
  home_faq: {
    badge: 'FAQ',
    title: 'Questions fréquemment posées',
    subtitle: 'Tout ce que vous devez savoir sur les spreadsheets AllChinaBuy et comment en tirer le meilleur parti.',
    q1: 'Qu\'est-ce qu\'un spreadsheet AllChinaBuy ?',
    a1: 'Un spreadsheet AllChinaBuy est une liste organisée de liens produits partagée dans la communauté rep et streetwear. Ces spreadsheets contiennent des liens directs vers des articles achetables via l\'agent AllChinaBuy.',
    q2: 'À quelle fréquence les spreadsheets sont-ils mis à jour ?',
    a2: 'Notre répertoire est mis à jour chaque semaine. Notre équipe examine de nouvelles soumissions, vérifie les liens existants et ajoute des trouvailles fraîches.',
    q3: 'Comment utiliser un spreadsheet pour passer une commande ?',
    a3: 'Parcourez notre répertoire et trouvez un produit. Cliquez vers la boutique principale pour accéder au spreadsheet complet. Copiez le lien et collez-le dans la barre de recherche de l\'agent AllChinaBuy.',
    q4: 'L\'accès aux spreadsheets est-il gratuit ?',
    a4: 'Oui, tous les spreadsheets répertoriés sont entièrement gratuits. Vous ne payez que les articles que vous choisissez d\'acheter avec les frais d\'agent et de livraison standard.',
    q5: 'Comment vérifiez-vous la qualité des produits ?',
    a5: 'Notre processus implique la vérification des évaluations vendeur, la révision des retours de la communauté et des photos QC. Seuls les spreadsheets avec des retours constamment positifs sont répertoriés.',
    q6: 'Puis-je soumettre mon propre spreadsheet ?',
    a6: 'Nous accueillons les contributions de la communauté. Si vous avez créé un spreadsheet de qualité, contactez-nous via la page contact de la boutique principale.',
  },
  home_cta: {
    title: "Prêt à trouver votre\nprochain super deal ?",
    subtitle: 'Rejoignez des milliers d\'acheteurs intelligents qui utilisent déjà notre répertoire. Mis à jour chaque semaine avec les dernières trouvailles vérifiées dans 14 catégories.',
    cta1: 'Parcourir les Spreadsheets',
    cta2: 'Lire le Guide',
  },
  home: {
    metaTitle: 'AllChinaBuy Spreadsheet — Trouvez des produits, vérifiez le QC et achetez malin',
    metaDescription:
      "Explorez le spreadsheet AllChinaBuy pour découvrir des trouvailles, comparer les catégories, comprendre le QC et les frais d'expédition. Guides d'achat indépendants en un seul endroit.",
    hero: {
      badge: "Guide d'achat indépendant",
      title: 'AllChinaBuy Spreadsheet — Trouvez des produits, vérifiez le QC et achetez malin',
      subtitle:
        "Explorez le spreadsheet AllChinaBuy, découvrez des trouvailles, comparez les catégories, comprenez le QC et les frais d'expédition, et suivez des guides d'achat pratiques en un seul endroit.",
    },
    what: {
      title: "Qu'est-ce que le Spreadsheet AllChinaBuy ?",
      p1: "Un spreadsheet AllChinaBuy est une liste organisée et partageable de trouvailles — liens, photos QC, notes vendeur et astuces d'expédition — qui vous aide à parcourir et acheter avec plus de confiance.",
      p2: 'La vraie valeur réside dans le filtrage. Les bons spreadsheets sont triés par catégorie, indiquent si un article a déjà été évalué et incluent de vraies photos QC pour éviter les erreurs courantes.',
      p1Title: 'Organisé, pas aléatoire',
      p2Title: 'Conçu pour vous faire gagner du temps',
    },
    categories: {
      title: 'Parcourir les catégories',
      subtitle: 'Choisissez une catégorie pour explorer des trouvailles sélectionnées.',
      placeholder: 'Choisissez une catégorie...',
      go: 'Aller à la catégorie',
      viewAll: 'Voir toutes les catégories',
    },
    articles: {
      title: 'Guides d\'achat & articles piliers',
      subtitle: 'Guides indépendants et originaux sur les avis AllChinaBuy, l\'expédition, le QC, les coupons, la sécurité et plus encore.',
      readMore: 'Lire l\'article',
    },
    guide: {
      title: 'Dernier guide du Spreadsheet',
      subtitle:
        'Nouveau sur le spreadsheet ? Commencez par notre guide complet sur les trouvailles, le QC et les achats intelligents.',
      cardTitle: 'AllChinaBuy Spreadsheet : le guide complet',
      cardText:
        "Découvrez comment fonctionne le spreadsheet, comment l'utiliser étape par étape et à quoi faire attention avant de commander.",
      read: 'Lire le guide',
    },
    faq: {
      title: 'Questions fréquentes',
      q1: "Qu'est-ce qu'un spreadsheet AllChinaBuy ?",
      a1: "C'est une liste organisée et partageable de trouvailles avec des liens, des photos QC et des notes pour parcourir et acheter avec plus de confiance.",
      q2: "Ce site est-il le site officiel d'AllChinaBuy ?",
      a2: "Non. Ceci est une ressource d'information indépendante, non affiliée ni approuvée par AllChinaBuy.",
      q3: "Ai-je besoin du spreadsheet pour acheter ?",
      a3: "Non, mais il vous fait gagner beaucoup de temps en vous offrant des liens sélectionnés et de vraies photos QC que vous devriez autrement trouver vous-même.",
      q4: "Combien coûte l'expédition ?",
      a4: "Cela varie selon le poids, la taille et la ligne d'expédition. Les articles légers coûtent moins cher, et regrouper les colis réduit généralement le total.",
    },
    finalCta: {
      title: 'Prêt à trouver votre prochain produit ?',
      text: 'Parcourez les catégories sélectionnées et lancez votre prochaine commande avec plus de confiance.',
    },
  },
};